import { render, staticRenderFns } from "./ServerSideValidation.vue?vue&type=template&id=7c474860&"
import script from "./ServerSideValidation.vue?vue&type=script&lang=js&"
export * from "./ServerSideValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports